import "../styles.css";

import { faChevronLeft } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Pagination from "@mui/material/Pagination";
import Typography from "@mui/material/Typography";
import React, { ChangeEvent } from "react";
import { useNavigate } from "react-router-dom";

import { useAccessibility } from "../../../../Store/contexts/AccessibilityContext";
import {
  sxPagination,
  sxPaginationContrast,
} from "../../../../assets/styles/CommonSxProps";
import LoadingApp from "../../../../components/LoadingApp";
import ModalFeedBack from "../../../../components/ModalFeedBack";
import { Convite } from "../../../../interfaces/entities/SaudeBemEstar/PalestrasEventos/Convite";
import { getInvitations } from "../../../../services/SaudeBemEstar/PalestrasEventosService";
import { InvitationWarningCard } from "../InvitationWarningCard";
import { InvitationCard } from "./InvitationCard";
import { scrollTo } from "../../../../utils/ScrollUtil";
import PageTitle from "../../../../components/Accessibility/PageTitle";

export default function PalestrasEventosConvites() {
  const rowsPerPage = 5;

  const [invitations, setInvitations] = React.useState<Convite[]>([]);
  const [loading, setLoading] = React.useState(false);
  const [openErrorModal, setOpenErrorModal] = React.useState(false);
  const [page, setPage] = React.useState(1);
  const [reload, setReload] = React.useState(false);

  const accessibility = useAccessibility();
  const navigate = useNavigate();

  const closeErrorModal = () => setOpenErrorModal(false);

  React.useEffect(() => {
    getAllInvitations();
  }, [reload]);

  const reloadPage=()=>{
    setReload(!reload)
  } 

  const getAllInvitations = () => {
    setLoading(true);
    getInvitations()
      .then((data) => {
        const sortedEvents = data.sort((a, b) => {
          const dateA = new Date(`${a.evento.data.split('/').reverse().join('-')}T${a.evento.hora}`).getTime();
          const dateB = new Date(`${b.evento.data.split('/').reverse().join('-')}T${b.evento.hora}`).getTime();
          return dateB - dateA;
        });
        setInvitations(sortedEvents);
      })
      .catch(() => setOpenErrorModal(true))
      .finally(() => setLoading(false));
  };

  const handlePageChange = (event: ChangeEvent<unknown>, newPage: number) => {
    setPage(newPage);
    scrollTo('scroll-ref');
  };

  const startIndex = (page - 1) * rowsPerPage;
  const endIndex = page * rowsPerPage;
  const eventElements = invitations
    ?.slice(startIndex, endIndex)
    .map((invitations, index) => {
      return <InvitationCard reloadPage={reloadPage} convite={invitations} key={index + startIndex} />;
    });

  return (
    <div className="palestras-eventos-content">
      <PageTitle text="Convites" id="scroll-ref" />
      {!loading && !invitations?.length && (
        <div>
          <Typography style={accessibility.textStyleAccessibilityWithMargin}>
            Você não possui nenhum convite para evento.
          </Typography>
          <Typography style={accessibility.textStyleAccessibility}>
            Você será notificado quando receber convites para eventos.
          </Typography>
        </div>
      )}
      {!loading && !!invitations?.length && (
        <InvitationWarningCard
          title="ATENÇÃO:"
          message="Caso não possa comparecer, lembre-se de cancelar a sua presença com antecedência"
        />
      )}
      {!loading && eventElements}
      {invitations?.length > rowsPerPage && (
        <Pagination
          count={Math.ceil(invitations.length / rowsPerPage)}
          sx={accessibility.contrastMode ? sxPaginationContrast : sxPagination}
          hideNextButton
          hidePrevButton
          color="primary"
          page={page}
          onChange={handlePageChange}
        />
      )}
      <button
        style={accessibility.textStyleAccessibility}
        className="back-button"
        onClick={() => navigate(-1)}
      >
        <FontAwesomeIcon
          style={accessibility.textStyleAccessibility}
          icon={faChevronLeft}
        />
        &nbsp;&nbsp;<u>Voltar</u>
      </button>
      <LoadingApp showLoading={loading} />
      <ModalFeedBack
        showModal={openErrorModal}
        handleShowModal={closeErrorModal}
        handleButtonModal={closeErrorModal}
        icon="error"
        title="Erro"
        subTitle="Ocorreu um erro. Tente novamente em instantes."
        textButton="Fechar"
        showButtonModal
      />
    </div>
  );
}
